import styled from 'styled-components'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { themeObject, textModels } from 'Pages/landings/newLandings/common/style'

export const IconWrapper = styled.a`
	flex-shrink: 1;
`

export const Tooltip = styled(ReactTooltip)`
	width: 315px;
	height: auto;
	padding: 8px 12px;
	${textModels('notAdaptive', 'xs', '400')};
	color: ${themeObject.colors.base.white};
	background: ${themeObject.colors.grey[900]};
	border-radius: 8px;
	box-sizing: border-box;
`
